export default "__VITE_ASSET__DYnIBXhb__"